import React from "react"

 type Props = {
  children: React.ReactNode,
  when: boolean
}

 const Show = ({children, when}: Props) => ( when ? children : null )


 export default Show;



// WEBPACK FOOTER //
// ./src/functional/Show.js